import {
    BooleanField,
    Datagrid,
    List,
    NumberField,
    TextField,
    TextInput,
  } from 'react-admin';
  
  export const ClergyList = () => {

    const searchFilters = [
      <TextInput
        source="name@ilike"
        alwaysOn
        label="Name"
      />,
    
    ];

  return(
    <List
    filters={searchFilters}
    perPage={50}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <NumberField source="id" />
        <TextField source="name" />
        <TextField source="address" />
        <TextField source="city" />
        <TextField source="state" />
        <TextField source="phone_number" />
        <TextField source="type" />
        <BooleanField source="active" />
      </Datagrid>
    </List>
  );
  
  }